module.exports = __webpack_public_path__ + "static/img/deloitte-rare-crs-data.f0577b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/deloitte-rare-crs-data.png
// module id = CFEO
// module chunks = 0